import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose, withStateHandlers } from 'recompose';

import DocumentViewer from '../../documentViewer';
import { querySubmissionItemGQL } from '../graphql';


export const rotateButtonProps = {
  disableRotate: PropTypes.bool.isRequired,
  startDisableRotate: PropTypes.func.isRequired,
  stopDisableRotate: PropTypes.func.isRequired,
};


export const withRotateButtonState = withStateHandlers(
  (props) => { return { disableRotate: false }; },
  {
    startDisableRotate: (state, props) => {
      return () => { return { disableRotate: true }; };
    },
    stopDisableRotate: (state, props) => {
      return () => { return { disableRotate: false }; };
    },
  },
);


const propTypes = exact({
  data: PropTypes.object,
});


const SubmissionItemViewer = (props) => {
  const { documentId } = props.data.submission_item;

  return (
    <DocumentViewer documentId={documentId} />
  );
};


SubmissionItemViewer.propTypes = propTypes;


const enhance = compose(querySubmissionItemGQL);


export default enhance(SubmissionItemViewer);
